import useSelector from '@app/hooks/useSelector';

import { getIndentationBlacklist, getIndentationSelect } from '../../../../reducers/downloadData/selectors';
import type { FileFormat, Indentation } from '../../../../types';
import IndentationInput from './IndentationInput';

const prepareOptions = (
    indentationSelect: Partial<Record<Indentation, string>> | undefined,
    blacklist: readonly Indentation[],
): { label: string; value: Indentation }[] => {
    if (!indentationSelect) {
        return [];
    }

    return Object.entries(indentationSelect)
        .filter(([value]) => !blacklist.includes(Number(value)))
        .map((item) => ({
            value: Number(item[0]) as Indentation,
            label: item[1] as string,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
};

interface IndentationInputContainerProps {
    value: Indentation;
    fileFormat: FileFormat;
    onChange: (value: Indentation) => void;
}

const IndentationInputContainer = ({ value, fileFormat, onChange }: IndentationInputContainerProps) => {
    const indentationSelect = useSelector(getIndentationSelect);
    const indentationBlacklist = useSelector(getIndentationBlacklist);

    const blacklist = indentationBlacklist?.[fileFormat] ?? [];

    const options = prepareOptions(indentationSelect, blacklist);

    return <IndentationInput value={value} options={options} onChange={onChange} />;
};

export default IndentationInputContainer;
